module.exports = __webpack_public_path__ + "media/warning.4c953d62.mp3";